import moment from 'moment';

import List from 'src/storage/list';

class DoctorModel extends List {
  id = 'doctor';
  defaultState = () => ({
    current: 'recent',
    specialist: [],
    appointmentTypes: ['in_office', 'virtual'],
    patientFlg: true,
    cityAddress: null,
    date: moment()
  });
  refreshOnInit = false;
  refreshOnSubscribe = false;
  loadingMore = false;
  sortBy = null;
  apiConfig = {
    refresh: {
      url: 'doctor/list',
      validation: {
        specialist: 'array',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'discovery_refreshed'
    },
    list: {
      url: 'doctor/list',
      validation: {
        specialist: 'array',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'doctor/list',
      validation: {
        specialist: 'array',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    doctor_detail: {
      url: 'doctor/detail',
      validation: {
        id: 'number'
      },
      cancellable: true
    },
    doctor_chat: {
      url: 'doctor/chat',
      validation: {
        id: 'number',
        patientFlg: 'boolean',
        patientNumber: 'string',
        fee: 'number'
      },
      cancellable: true
    },
    book_doctor: {
      url: 'doctor/book',
      validation: {
        id: 'number',
        bookDate: 'bookDate',
        bookTime: 'bookTime',
        firstName: 'firstName',
        lastName: 'lastName',
        phoneNumber: 'phoneNumber',
        email: 'emailAddress',
        disease: 'string',
        city: 'string',
        description: 'string'
      },
      cancellable: true
    }
  };
  _events = {
    profile: 'handleProfile',
    '/discovery:query': 'handleQuerySearch',
    location: 'initLocation',

    'foxsocket:message:msg': 'onMessage',
    'foxsocket:message:msg_update': 'onMessage',
    discovery_refreshed: 'onDiscoveryRefreshed',
    'foxsocket:message:slot_taken': 'onSlotTakenWS'
  };

  onSlotTakenWS = ({ data }) => {
    let { doctorId, slotId } = data;
    this.log('onSlotTaken', { doctorId, slotId });
    let items = this.items()
      .map((item) => {
        if (item.id == doctorId) {
          item.slots = item.slots.filter((slot) => slot.id != slotId);
        }
        return item;
      })
      .filter((item) => item.slots && item.slots.length > 0);
    this.setListState({ items });
  };

  onDiscoveryRefreshed = (items) => {
    if (items && items.length > 0 && items[0].slots && items[0].slots.length > 0) {
      this.setState({
        date: moment(items[0].slots[0].startDate)
      });
    }
  };

  onMessage = ({ channel, data }) => {
    let userId = this.state.user?.id;

    if (channel !== 'u-' + userId || !data.data?.slotId) return;
    let items = this.items('recent');

    let doctorId = data.from !== userId ? data.from : data.to;

    let exist = false;

    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      if (item.id === doctorId) {
        item.slots = item.slots.filter((slot) => {
          if (slot.id === data.data.slotId) {
            exist = true;
          }
          return !(slot.id === data.data.slotId && data.data.status !== 'cancelled');
        });

        if (
          !exist &&
          data.data.status === 'cancelled' &&
          moment(item.slots[0]?.startDate).isSame(moment(data.data?.startDate), 'day')
        ) {
          item.slots = this.sort(
            [
              ...item.slots,
              {
                id: data.data.slotId,
                startDate: data.data.startDate,
                endDate: data.data.endDate
              }
            ],
            { key: 'startDate', desc: false }
          );
        }

        this.setListState({ items }, 'recent', null, true);
        this.triggerDelay();
        break;
      }
    }
  };

  handleProfile = (profile) => {
    this.setState({ user: profile });
  };

  initLocation = (data) => {
    this.setState({ tempAddress: { countryAddress: data.country, cityAddress: data.city } });
  };
  handleQuerySearch = (v) => {
    this.handleChangeSearch(v);
  };

  listParams(loadMore) {
    const req = {
      specialist: this.state.specialist || [],
      cityAddress: this.state.cityAddress || '',
      appointmentType: this.state.appointmentTypes.length > 1 ? '' : this.state.appointmentTypes[0],
      hospital: this.state.hospital || '',
      date: this.state.date ? this.state.date.startOf('day').valueOf() : '',
      skip: 0,
      limit: this.listLimit
    };

    const query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }

    if (req.specialist.length === 0 && (!req.query || req.query.length < 3)) {
      return null;
    }

    const searchDoctor = this.listInput('searchDoctor');
    if (searchDoctor && searchDoctor.query === req.query) {
      req.doctorId = searchDoctor.id;
    }

    this.loadingMore = loadMore;
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }
}

const model = new DoctorModel();
export default model;
